import * as Types from '../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddResumeCertificationsMutationVariables = Types.Exact<{
  input: Types.AddJobSeekerProfileResumeCertificationsInput;
}>;


export type AddResumeCertificationsMutation = { __typename?: 'Mutation', addJobSeekerProfileResumeCertifications?: { __typename?: 'AddJobSeekerProfileResumeCertificationsPayload', certifications: Array<{ __typename?: 'JobSeekerProfileCertification', id: string, title?: string | null }> } | null };

export type UpdateResumeCertificationsMutationVariables = Types.Exact<{
  input: Types.UpdateJobSeekerProfileResumeCertificationsInput;
}>;


export type UpdateResumeCertificationsMutation = { __typename?: 'Mutation', updateJobSeekerProfileResumeCertifications?: { __typename?: 'UpdateJobSeekerProfileResumeCertificationsPayload', certifications: Array<{ __typename?: 'JobSeekerProfileCertification', id: string, title?: string | null }> } | null };

export type AddResumeLicensesMutationVariables = Types.Exact<{
  input: Types.AddJobSeekerProfileResumeLicensesInput;
}>;


export type AddResumeLicensesMutation = { __typename?: 'Mutation', addJobSeekerProfileResumeLicenses?: { __typename?: 'AddJobSeekerProfileResumeLicensesPayload', licenses: Array<{ __typename?: 'JobSeekerProfileLicense', id: string, title?: string | null }> } | null };

export type UpdateResumeLicensesMutationVariables = Types.Exact<{
  input: Types.UpdateJobSeekerProfileResumeLicensesInput;
}>;


export type UpdateResumeLicensesMutation = { __typename?: 'Mutation', updateJobSeekerProfileResumeLicenses?: { __typename?: 'UpdateJobSeekerProfileResumeLicensesPayload', licenses: Array<{ __typename?: 'JobSeekerProfileLicense', id: string, title?: string | null }> } | null };

export type AddResumeLanguagesMutationVariables = Types.Exact<{
  input: Types.AddJobSeekerProfileResumeLanguagesInput;
}>;


export type AddResumeLanguagesMutation = { __typename?: 'Mutation', addJobSeekerProfileResumeLanguages?: { __typename?: 'AddJobSeekerProfileResumeLanguagesPayload', languages: Array<{ __typename?: 'JobSeekerProfileLanguage', id: string }> } | null };

export type UpdateResumeLanguagesMutationVariables = Types.Exact<{
  input: Types.UpdateJobSeekerProfileResumeLanguagesInput;
}>;


export type UpdateResumeLanguagesMutation = { __typename?: 'Mutation', updateJobSeekerProfileResumeLanguages?: { __typename?: 'UpdateJobSeekerProfileResumeLanguagesPayload', languages: Array<{ __typename?: 'JobSeekerProfileLanguage', id: string }> } | null };


export const AddResumeCertificationsDocument = gql`
    mutation AddResumeCertifications($input: AddJobSeekerProfileResumeCertificationsInput!) {
  addJobSeekerProfileResumeCertifications(input: $input) {
    certifications {
      id
      title
    }
  }
}
    `;
export type AddResumeCertificationsMutationFn = Apollo.MutationFunction<AddResumeCertificationsMutation, AddResumeCertificationsMutationVariables>;

/**
 * __useAddResumeCertificationsMutation__
 *
 * To run a mutation, you first call `useAddResumeCertificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResumeCertificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResumeCertificationsMutation, { data, loading, error }] = useAddResumeCertificationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddResumeCertificationsMutation(baseOptions?: Apollo.MutationHookOptions<AddResumeCertificationsMutation, AddResumeCertificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddResumeCertificationsMutation, AddResumeCertificationsMutationVariables>(AddResumeCertificationsDocument, options);
      }
export type AddResumeCertificationsMutationHookResult = ReturnType<typeof useAddResumeCertificationsMutation>;
export type AddResumeCertificationsMutationResult = Apollo.MutationResult<AddResumeCertificationsMutation>;
export type AddResumeCertificationsMutationOptions = Apollo.BaseMutationOptions<AddResumeCertificationsMutation, AddResumeCertificationsMutationVariables>;
export const UpdateResumeCertificationsDocument = gql`
    mutation UpdateResumeCertifications($input: UpdateJobSeekerProfileResumeCertificationsInput!) {
  updateJobSeekerProfileResumeCertifications(input: $input) {
    certifications {
      id
      title
    }
  }
}
    `;
export type UpdateResumeCertificationsMutationFn = Apollo.MutationFunction<UpdateResumeCertificationsMutation, UpdateResumeCertificationsMutationVariables>;

/**
 * __useUpdateResumeCertificationsMutation__
 *
 * To run a mutation, you first call `useUpdateResumeCertificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResumeCertificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResumeCertificationsMutation, { data, loading, error }] = useUpdateResumeCertificationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResumeCertificationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResumeCertificationsMutation, UpdateResumeCertificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResumeCertificationsMutation, UpdateResumeCertificationsMutationVariables>(UpdateResumeCertificationsDocument, options);
      }
export type UpdateResumeCertificationsMutationHookResult = ReturnType<typeof useUpdateResumeCertificationsMutation>;
export type UpdateResumeCertificationsMutationResult = Apollo.MutationResult<UpdateResumeCertificationsMutation>;
export type UpdateResumeCertificationsMutationOptions = Apollo.BaseMutationOptions<UpdateResumeCertificationsMutation, UpdateResumeCertificationsMutationVariables>;
export const AddResumeLicensesDocument = gql`
    mutation AddResumeLicenses($input: AddJobSeekerProfileResumeLicensesInput!) {
  addJobSeekerProfileResumeLicenses(input: $input) {
    licenses {
      id
      title
    }
  }
}
    `;
export type AddResumeLicensesMutationFn = Apollo.MutationFunction<AddResumeLicensesMutation, AddResumeLicensesMutationVariables>;

/**
 * __useAddResumeLicensesMutation__
 *
 * To run a mutation, you first call `useAddResumeLicensesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResumeLicensesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResumeLicensesMutation, { data, loading, error }] = useAddResumeLicensesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddResumeLicensesMutation(baseOptions?: Apollo.MutationHookOptions<AddResumeLicensesMutation, AddResumeLicensesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddResumeLicensesMutation, AddResumeLicensesMutationVariables>(AddResumeLicensesDocument, options);
      }
export type AddResumeLicensesMutationHookResult = ReturnType<typeof useAddResumeLicensesMutation>;
export type AddResumeLicensesMutationResult = Apollo.MutationResult<AddResumeLicensesMutation>;
export type AddResumeLicensesMutationOptions = Apollo.BaseMutationOptions<AddResumeLicensesMutation, AddResumeLicensesMutationVariables>;
export const UpdateResumeLicensesDocument = gql`
    mutation UpdateResumeLicenses($input: UpdateJobSeekerProfileResumeLicensesInput!) {
  updateJobSeekerProfileResumeLicenses(input: $input) {
    licenses {
      id
      title
    }
  }
}
    `;
export type UpdateResumeLicensesMutationFn = Apollo.MutationFunction<UpdateResumeLicensesMutation, UpdateResumeLicensesMutationVariables>;

/**
 * __useUpdateResumeLicensesMutation__
 *
 * To run a mutation, you first call `useUpdateResumeLicensesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResumeLicensesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResumeLicensesMutation, { data, loading, error }] = useUpdateResumeLicensesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResumeLicensesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResumeLicensesMutation, UpdateResumeLicensesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResumeLicensesMutation, UpdateResumeLicensesMutationVariables>(UpdateResumeLicensesDocument, options);
      }
export type UpdateResumeLicensesMutationHookResult = ReturnType<typeof useUpdateResumeLicensesMutation>;
export type UpdateResumeLicensesMutationResult = Apollo.MutationResult<UpdateResumeLicensesMutation>;
export type UpdateResumeLicensesMutationOptions = Apollo.BaseMutationOptions<UpdateResumeLicensesMutation, UpdateResumeLicensesMutationVariables>;
export const AddResumeLanguagesDocument = gql`
    mutation AddResumeLanguages($input: AddJobSeekerProfileResumeLanguagesInput!) {
  addJobSeekerProfileResumeLanguages(input: $input) {
    languages {
      id
    }
  }
}
    `;
export type AddResumeLanguagesMutationFn = Apollo.MutationFunction<AddResumeLanguagesMutation, AddResumeLanguagesMutationVariables>;

/**
 * __useAddResumeLanguagesMutation__
 *
 * To run a mutation, you first call `useAddResumeLanguagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResumeLanguagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResumeLanguagesMutation, { data, loading, error }] = useAddResumeLanguagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddResumeLanguagesMutation(baseOptions?: Apollo.MutationHookOptions<AddResumeLanguagesMutation, AddResumeLanguagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddResumeLanguagesMutation, AddResumeLanguagesMutationVariables>(AddResumeLanguagesDocument, options);
      }
export type AddResumeLanguagesMutationHookResult = ReturnType<typeof useAddResumeLanguagesMutation>;
export type AddResumeLanguagesMutationResult = Apollo.MutationResult<AddResumeLanguagesMutation>;
export type AddResumeLanguagesMutationOptions = Apollo.BaseMutationOptions<AddResumeLanguagesMutation, AddResumeLanguagesMutationVariables>;
export const UpdateResumeLanguagesDocument = gql`
    mutation UpdateResumeLanguages($input: UpdateJobSeekerProfileResumeLanguagesInput!) {
  updateJobSeekerProfileResumeLanguages(input: $input) {
    languages {
      id
    }
  }
}
    `;
export type UpdateResumeLanguagesMutationFn = Apollo.MutationFunction<UpdateResumeLanguagesMutation, UpdateResumeLanguagesMutationVariables>;

/**
 * __useUpdateResumeLanguagesMutation__
 *
 * To run a mutation, you first call `useUpdateResumeLanguagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResumeLanguagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResumeLanguagesMutation, { data, loading, error }] = useUpdateResumeLanguagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResumeLanguagesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResumeLanguagesMutation, UpdateResumeLanguagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResumeLanguagesMutation, UpdateResumeLanguagesMutationVariables>(UpdateResumeLanguagesDocument, options);
      }
export type UpdateResumeLanguagesMutationHookResult = ReturnType<typeof useUpdateResumeLanguagesMutation>;
export type UpdateResumeLanguagesMutationResult = Apollo.MutationResult<UpdateResumeLanguagesMutation>;
export type UpdateResumeLanguagesMutationOptions = Apollo.BaseMutationOptions<UpdateResumeLanguagesMutation, UpdateResumeLanguagesMutationVariables>;